import React from "react";
import { createPortal } from "react-dom";
import { Trash2 } from "lucide-react";

/**
 * Dark-neon "Confirm Your Bids" modal — shared by Jodi / Haruf / Crossing pages.
 * rows: [{ key, label, amount }]
 */
export default function ConfirmBidsModal({ open, rows, total, onClose, onConfirm, onDelete, submitting = false }) {
  if (!open) return null;
  return createPortal(
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center p-4"
      style={{ background: "radial-gradient(ellipse 60% 50% at 50% 50%, rgba(10,24,41,0.95) 0%, rgba(4,8,18,0.98) 100%)" }}
      onClick={onClose}
      data-testid="confirm-bids-overlay"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-md rounded-2xl border border-cyan-400/40 shadow-[0_0_60px_rgba(56,189,248,0.25)]"
        style={{ background: "linear-gradient(180deg,#0a1829 0%,#060e1b 100%)" }}
        data-testid="confirm-bids-modal"
      >
        <div className="p-5 pb-3 text-center">
          <h2 className="font-display font-black text-white text-xl tracking-wide">बोली कन्फर्म करें</h2>
        </div>
        <div className="px-4 pb-3 space-y-2 max-h-[55vh] overflow-y-auto">
          {rows.length === 0 ? (
            <div className="text-center text-slate-500 py-8 text-sm">कोई बोली नहीं — बंद करें</div>
          ) : (
            rows.map((row) => (
              <div
                key={row.key}
                className="flex items-center justify-between rounded-xl border border-cyan-400/15 bg-cyan-400/5 px-4 py-3"
                data-testid={`confirm-row-${row.key}`}
              >
                <div className="text-white font-bold text-sm">{row.label}</div>
                <div className="flex items-center gap-3">
                  <span className="text-cyan-300 font-black tabular-nums">₹{row.amount}</span>
                  <button
                    onClick={() => onDelete(row.key)}
                    data-testid={`confirm-delete-${row.key}`}
                    className="w-8 h-8 rounded-lg bg-rose-500/15 border border-rose-500/30 text-rose-400 flex items-center justify-center active:scale-95"
                    aria-label="Remove"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
        <div className="px-5 py-3 border-t border-cyan-400/15 flex items-center justify-between">
          <span className="text-slate-300 text-sm">कुल बोली राशि:</span>
          <span className="font-display font-black text-cyan-300 text-xl tabular-nums">₹ {total.toFixed(2)}</span>
        </div>
        <div className="px-5 pb-5 pt-2 grid grid-cols-2 gap-3">
          <button
            onClick={onClose}
            data-testid="confirm-edit-btn"
            className="h-12 rounded-xl bg-slate-700/60 border border-slate-600 text-white font-black tracking-wide active:scale-95"
          >
            एडिट करें
          </button>
          <button
            onClick={onConfirm}
            disabled={submitting || rows.length === 0}
            data-testid="confirm-bid-btn"
            className="h-12 rounded-xl font-black text-white tracking-wide active:scale-95 disabled:opacity-50 shadow-[0_8px_24px_-6px_rgba(56,189,248,0.6)]"
            style={{ background: "linear-gradient(135deg,#22d3ee 0%,#2563eb 100%)" }}
          >
            {submitting ? "लग रही है…" : "कन्फर्म बोली"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
